import { useEffect, useState } from 'react';
import { Collection } from 'firestorter';

import BaseDocument from '../../../../Model/BaseDocument';
import { firestorePaths } from '../../../../utils/paths';
import { reportError } from '../utils/reportError';

const FAILED_STATUSES = ['BOUNCED', 'FAILED'];
const FAILED_MSGS_LIMIT = 200;

const useCampaignFailedMsgs = (campaignId) => {
  const [collection, setCollection] = useState(null);
  const [loading, setLoading] = useState(Boolean(campaignId));
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!campaignId) {
      setCollection(null);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let cancelled = false;
    let activeCollection = null;
    setLoading(true);
    setError(false);

    const load = async () => {
      try {
        const col = new Collection(firestorePaths.LEAD_CAMPAIGN_MSGS, {
          createDocument: (src, opts) => new BaseDocument(src, { ...opts, disableObserverRefCount: true }),
          query: (ref) => ref
            .where('campaignId', '==', campaignId)
            .where('deliveryStatus', 'in', FAILED_STATUSES)
            .limit(FAILED_MSGS_LIMIT),
        });
        await BaseDocument.initCollection(col);
        if (cancelled) {
          col.mode = 'off';
          return;
        }
        activeCollection = col;
        setCollection(col);
      } catch (err) {
        reportError('listFailedMsgs', err);
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
      if (activeCollection) activeCollection.mode = 'off';
    };
  }, [campaignId]);

  return {
    docs: collection?.docs ?? [],
    loading,
    error,
  };
};

export { useCampaignFailedMsgs, FAILED_MSGS_LIMIT };
